export const CardNote=" يرجى دفع المبلغ للمندوب خلال مدة اقصاها 3 ايام تجنبا لأنقطاع الخدمة"